module.exports = __webpack_public_path__ + "img/Couple-dependant.59d6da44.svg";